import { render, staticRenderFns } from "./aiTextSetting.vue?vue&type=template&id=7dc8c01a"
import script from "./aiTextSetting.vue?vue&type=script&lang=js"
export * from "./aiTextSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports